
import { setAttributeToElements } from "~/utils";
import UiSwiperCarousel from "~/components/UI/UiSwiperCarousel.vue";

export default {
  name: "MainSlider",
  components: {
    UiSwiperCarousel,
  },
  props: {
    article: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    image() {
      return this.article?.medias?.find((el) => el.position === "list") || "";
    },
  },
  mounted() {
    setAttributeToElements("a.hidden-ssr-link", "tabindex", "0");
  },
};
